import OrganizationGallerySummary from "./OrganizationGallerySummary";

export default OrganizationGallerySummary;
